import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	menuItem: {
		alignItems: "center",
		color: "#FFFFFF",
		display: "inline-flex",
		gap: theme.spacing(1),
		opacity: 1,
		padding: theme.spacing(1, 0),
		transition: "color 300ms ease",
		whiteSpace: "nowrap",
		"&:hover": {
			color: theme.palette.primary.main
		},
		"&.mco-view-component-header-desktop-menu-item-level2": {
			color: theme.palette.text.primary,
			display: "inline-block",
			margin: theme.spacing(1, 0),
			padding: theme.spacing(0.5, 0),
			transition: "color 300ms ease",
			"&:hover": {
				color: theme.palette.text.primary,
				"&.mco-view-component-header-desktop-menu-item--selected, &.mco-link--active": {
					color: theme.palette.primary.dark
				}
			}
		},
		"&.mco-view-component-header-desktop-menu-item-level3": {
			color: theme.palette.common.white,
			transition: "color 300ms ease"
		},
		"&.mco-view-component-header-desktop-menu-item-level1": {
			borderBottom: "3px solid transparent",
			borderTop: "3px solid transparent",
			color: "#FFFFFF",
			opacity: 1,
			padding: theme.spacing(3, 0),
			transition: "border-bottom 250ms ease",
			"&:hover": {
				borderBottom: "3px solid #FFFFFF"
			},
			"&.mco-view-component-header-desktop-menu-item--selected, &.mco-link--active": {
				color: "#FFFFFF",
				borderBottom: "3px solid #FFFFFF"
			}
		}
	}
}));

export default styles;
